import React from "react";
import SubjectRegistry, { calcAge } from "../components/SubjectRegistry";

const FIELDS = [
  { key: "name", label: "e.name", required: true },
  { key: "id_number", label: "e.id_number" },
  { key: "position", label: "e.position" },
  { key: "department", label: "e.department" },
  { key: "hire_date", label: "e.hire_date", type: "date" },
  { key: "nationality", label: "e.nationality", type: "country" },
  { key: "birth_date", label: "e.birth_date", type: "date", required: true, hint: (form, t) => `${t("e.age")}: ${calcAge(form.birth_date)}` },
  { key: "gender", label: "e.gender", type: "select", required: true, options: [{ v: "Masculino", labelKey: "e.gender.m" }, { v: "Femenino", labelKey: "e.gender.f" }, { v: "Otro", labelKey: "e.gender.o" }] },
  { key: "blood_type", label: "e.blood_type", type: "select", required: true, options: ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-"] },
  { key: "allergic", label: "e.allergic", type: "yesno", required: true },
  { key: "allergy_detail", label: "e.allergy_detail", reqIfAllergic: true },
  { key: "medical_conditions", label: "e.medical_conditions", required: true },
  { key: "is_pep", label: "e.is_pep", type: "yesno" },
];

export default function Employees() {
  return <SubjectRegistry kind="employee" titleKey="k.employees" subKey="k.employees_sub" addKey="k.new_employee" fields={FIELDS} testid="employees" />;
}
